import React from 'react';
import getParameterFromURL from "../../../utils/getParameterFromUrl"
import { withAppStepsState } from "./../../../shared/containers/containerAppStepsState"
import { withStepsState } from "./../../../shared/containers/containerStepsState"
import { useSelector } from 'react-redux';

import ToPrevStepButton from "./../../../shared/toPrevStepButton"
import LogoSteps from "./logoSteps"
import { steps } from "./../../../shared/static.steps"
import ProgressSteps from "./progressSteps"

import styles from "./headerAppSteps.module.scss"

  
const HeaderAppSteps = (props) => {
  const totalSteps = Object.keys(steps).length;

  const { currentIndex } = props
  let firstQuestionC = (getParameterFromURL("firstQuestionC") === "true");
  let firstQuestionD = (getParameterFromURL("firstQuestionD") === "true");

  if (
    currentIndex === 0 && firstQuestionC
    ||
    currentIndex === 0 && firstQuestionD
    ) return '';

  return (
    <div className={styles.headerAppSteps}>
      <div className={styles.container_controls}>
        <ToPrevStepButton />
      </div>

      <LogoSteps />

      <div className={styles.stepsCounter}>
        <span className={styles.currentStep}>{currentIndex + 1}</span>/
        <span className={styles.totalSteps}>{totalSteps}</span>
      </div>

      <div className={styles.container_progress}>
        <ProgressSteps />
      </div>
    </div>
  )
}

export default withAppStepsState(withStepsState(HeaderAppSteps));